import { Component, Input } from '@angular/core';
import {
    BookingSummaryResult,
    BookingStatus
} from "models";

@Component({
    selector: 'app-booking-status',
    template: require('./booking-status.component.html'),
    styles: [require('./booking-status.component.scss')]
})

export class BookingStatusComponent {

    @Input() bookingSummaryResult: BookingSummaryResult;

    guestBookingStatusCssClass(result: BookingSummaryResult): string {
        if (result.guestBookingStatus === BookingStatus.cancelled) return 'bg-gray-100 text-gray-800';
        if (result.guestBookingStatus === BookingStatus.rejected) return 'bg-red-100 text-red-900';
        return result.guestBookingStatus === BookingStatus.notApproved ? 'bg-red-100 text-red-900' : 'bg-green-100 text-green-800';
    }
}